<template>
    <div class="card">
        <div class="card-header">
            <i class="fas fa-list me-2"></i>{{ TR.products }}
        </div>

        <div class="card-body">
            <DADataTableLazy
                v-if="tableOptions"
                ref="product_table_ref"
                :tableData="[]"
                :tableOptions="tableOptions"
                :lazyUrl="lazyUrl"
            />
        </div>

    </div>
</template>


<script scoped>
    import { ref, watchEffect, onBeforeMount } from "vue";

    import { useStore } from "@/store";
    import moment from 'moment-timezone';

    // import { useRouter } from "vue-router";
    // import { FilterMatchMode } from 'primevue/api';

    import { G, ajax } from "@/_common";

    import DADataTableLazy from "@/components/table/DADataTableLazy";

    export default {
        name: 'ProductsPage',
        title: 'products',
        components: {
            DADataTableLazy,
        },
        setup () {
            const store = useStore();
            // const router = useRouter();

            const tableOptions = ref();
            const filters = ref([]);
            const category = ref([]);
            const product_table_ref = ref();
            const TR = ref({});

            const lazyUrl = ref(store.getProductsLazy());

            onBeforeMount(async () => {

                // await getProducts();

                await ajax({
                    url: store.getFiltersByGroupID(0),
                    success: (e) => {
                        const res = e.data || null;
                        if (res) {
                            res.forEach(a => {
                                filters.value = filters.value.concat(a.group_filters.map(f => (
                                    { value: f.id, label: `${a.translate[0].name} / ${f.translate[0].name}` }
                                )));
                            });
                        }
                    }
                });

                await ajax({
                    url: store.getCategoryList(),
                    success: (e) => {
                        const res = e.data || null;
                        if (res) {
                            category.value.push({ value: 0, label: `<b>${TR.value.empty}</b>` });
                            category.value = category.value.concat(res.map(a => (
                                { value: a.id, label: a.translate[0].name }
                            )));
                            // res.filter(r => r.parent != 0).forEach(a => {
                            //     category.value.forEach((c, i) => {
                            //         if( a.parent == c.value ){
                            //             category.value.splice(i, 1);
                            //         }
                            //     });
                            // });
                            // category.value = category.value.concat(res.filter(r => r.parent != 0).map(a => (
                            //     { value: a.id, label: a.translate[0].name }
                            // )));
                        }
                    }
                });

                tableOptions.value = {
                    row_total: true,
                    row_total_field: ['price'],
                    // date_columns: {'create_date': 'datetime'},
                    // row_per_page: 5,
                    // export_button: false,

                    header_buttons:[
                        {
                            private: G.privateIfNotPermission("add"),
                            label: TR.value.add_title,
                            icon: 'fas fa-plus me-1',
                            class: 'btn-primary',
                            eventCallback: () => {
                                G.showModal({
                                    title: TR.value.add_title,
                                    page: 'pages/products/ProductsInfo',
                                    data: {
                                        permission_method: 'add'
                                    },
                                    table_columns_forlang: [
                                        {
                                            name: "name",
                                            title: TR.value.name,
                                            field_type: "text",
                                            required: true,
                                        },
                                        {
                                            name: "description",
                                            title: TR.value.about,
                                            field_type: "editor",
                                        },
                                    ],
                                    table_columns: [
                                        // {
                                        //     name: "product_code",
                                        //     title: TR.value.code,
                                        //     field_type: "selectbox",
                                        //     selectbox_items: [],
                                        //     showList: false,
                                        //     onInput: (e, item) => getProductCodes(e, item),
                                        //     selectbox_item_selected: null,
                                        //     required: true,
                                        // },
                                        // {
                                        //     name: "product_code",
                                        //     title: TR.value.code,
                                        //     field_type: "text",
                                        //     required: true,
                                        // },
                                        // {
                                        //     name: "name",
                                        //     title: TR.value.name,
                                        //     field_type: "text",
                                        //     required: true,
                                        // },
                                        // {
                                        //     name: "description",
                                        //     title: TR.value.description,
                                        //     field_type: "textarea",
                                        // },
                                        // {
                                        //     name: "quantity",
                                        //     title: TR.value.quantity,
                                        //     field_type: "integer",
                                        //     required: true,
                                        //     grouping: false,
                                        //     max: 100000000,
                                        // },
                                        // {
                                        //     name: "comein_price",
                                        //     title: TR.value.come_in_price,
                                        //     field_type: "currency",
                                        //     required: true,
                                        //     max: 100000000.00,
                                        // },
                                        {
                                            name: "price",
                                            title: TR.value.price,
                                            // field_type: "currency",
                                            field_type: "numeric",
                                            required: true,
                                            max: 100000000.00,
                                            default: 1,
                                            grouping: true,
                                        },
                                        {
                                            name: "years",
                                            title: TR.value.year,
                                            field_type: "integer",
                                            max: 3000,
                                            default: 2020,
                                        },
                                        {
                                            name: "months",
                                            title: TR.value.month,
                                            field_type: "integer",
                                            max: 12,
                                            default: 1,
                                        },
                                        {
                                            name: "quarters",
                                            title: TR.value.quarter,
                                            field_type: "integer",
                                            max: 4,
                                            default: 1,
                                        },
                                        // {
                                        //     name: "old_price",
                                        //     title: TR.value.old_price,
                                        //     field_type: "currency",
                                        //     max: 100000000.00,
                                        // },
                                        {
                                            name: "category_id",
                                            title: TR.value.category,
                                            // field_type: "dropdown_group",
                                            field_type: "dropdown",
                                            dropdown_items: category.value,
                                            dropdown_item_selected: category.value[0].value,
                                            // grouping: true,
                                            // groupLabelField: 'label',
                                            // groupItemsField: 'items',
                                        },
                                        {
                                            name: "product_filters",
                                            title: TR.value.filters,
                                            field_type: "multiselect",
                                            dropdown_items: filters.value,
                                            dropdown_item_selected: [],
                                            // onChange: (e, s) => {
                                            //     console.log(s, e);
                                            //     (document.getElementById('EventTypeSelection')
                                            //         .getElementsByClassName('ui-multiselect-label-container')[0]
                                            //         .getElementsByClassName('ui-multiselect-label')[0]).textContent = this.SelectedEventTypes.length + ' ausgewählt';
                                            // }
                                        },
                                        // {
                                        //     name: "model",
                                        //     title: TR.value.model,
                                        //     field_type: "text",
                                        // },
                                        // // {
                                        // //     name: "width",
                                        // //     title: TR.value.width,
                                        // //     field_type: "integer",
                                        // //     max: 100000000,
                                        // // },
                                        // // {
                                        // //     name: "height",
                                        // //     title: TR.value.height,
                                        // //     field_type: "integer",
                                        // //     max: 100000000,
                                        // // },
                                        // // {
                                        // //     name: "box",
                                        // //     title: TR.value.box,
                                        // //     field_type: "integer",
                                        // //     max: 100000000,
                                        // // },
                                        // // {
                                        // //     name: "per_box",
                                        // //     title: TR.value.per_box,
                                        // //     field_type: "integer",
                                        // //     max: 100000000,
                                        // // },
                                        // // {
                                        // //     name: "weight",
                                        // //     title: TR.value.weight,
                                        // //     field_type: "integer",
                                        // //     max: 100000000,
                                        // // },
                                        // // {
                                        // //     name: "length",
                                        // //     title: TR.value.length,
                                        // //     field_type: "integer",
                                        // //     max: 100000000,
                                        // // },
                                        // {
                                        //     name: "ean",
                                        //     title: TR.value.ean,
                                        //     field_type: "text",
                                        // },
                                        // {
                                        //     name: "sku",
                                        //     title: TR.value.sku,
                                        //     field_type: "text",
                                        // },
                                        // {
                                        //     name: "upc",
                                        //     title: TR.value.upc,
                                        //     field_type: "text",
                                        // },
                                        // {
                                        //     name: "isbn",
                                        //     title: TR.value.isbn,
                                        //     field_type: "text",
                                        // },
                                        // {
                                        //     name: "jan",
                                        //     title: TR.value.jan,
                                        //     field_type: "text",
                                        // },
                                        // {
                                        //     name: "mpn",
                                        //     title: TR.value.mpn,
                                        //     field_type: "text",
                                        // },
                                        {
                                            name: "status",
                                            title: TR.value.status,
                                            value: () => true,
                                            field_type: "switch",
                                        },
                                    ],
                                    toolbar: {
                                        leftSide: {
                                            buttons: [
                                                {
                                                    label: TR.value.close,
                                                    icon: "fas fa-times",
                                                    class: "btn-secondary",
                                                    eventCallback: (el) => {
                                                        G.closeModal(el);
                                                    },
                                                },
                                                {
                                                    private: G.privateIfNotPermission("add"),
                                                    label: TR.value.save,
                                                    icon: "fas fa-save",
                                                    class: "btn-primary",
                                                    eventCallback: async (res) => {
                                                        let e = res.newdata;

                                                        let formData = new FormData();
                                                        if( e.images.length ){
                                                            Array.from(e.images).forEach(file => {
                                                                if( file instanceof Object ){
                                                                    formData.append('upload_image', file);
                                                                }
                                                            });
                                                        }
                                                        let product_data = {
                                                            // "product_code": e.product_code,
                                                            "category_id": e.category_id || null,
                                                            // "quantity": e.quantity,
                                                            // "come_in_price": e.come_in_price,
                                                            // "old_price": e.old_price,
                                                            "price": e.price,
                                                            "years": e.years,
                                                            "months": e.months,
                                                            "quarters": e.quarters,
                                                            // "upc": e.upc,
                                                            // "model": e.model,
                                                            "status": e.status ? 1 : 0,
                                                            "translate": G.lang_list.map((a) => (
                                                                {
                                                                    "lang_id": a.value,
                                                                    "name": e.name[a.value] || e.name[1],
                                                                    "description": e.description[a.value],
                                                                }
                                                            )),
                                                            "product_images": e.new_product_images,
                                                            "product_filters": e.product_filters,
                                                        };

                                                        formData.append("data", JSON.stringify(product_data));

                                                        await ajax({
                                                            url: store.getProducts(),
                                                            method: 'post',
                                                            data: formData,
                                                            success: (x) => {
                                                                const res = x.data || null;
                                                                if ( x.status == 200 && res) {
                                                                    // res.create_date = new Date(res.create_date);
                                                                    res.create_date = moment.utc(res.create_date).tz(G.systemData.timezone?.value).format(G.datetime_format['datetime']);
                                                                    product_table_ref.value.tableData.unshift(res);
                                                                    product_table_ref.value.reCalculateTotal();
                                                                    G.alert.success(TR.value.msg_add_success);
                                                                }
                                                                else
                                                                    G.alert.error(res.detail);
                                                            },
                                                        });
                                                        G.closeModal(res);
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                });
                            },
                        },
                    ],
                    row_buttons: [
                        {
                            private: G.privateIfNotPermission("remove"),
                            title: TR.value.remove,
                            icon: "fas fa-trash",
                            class: "text-danger",
                            eventCallback: (data) => {
                                G.alert.confirm({ title: TR.value.warning, msg: TR.value.msg_remove_user, yesTitle: TR.value.yes, yes: async () => {
                                    await ajax({
                                        url: store.getProductsUpdate(data.id),
                                        method: 'delete',
                                        success: (e) => {
                                            const res = e.data || null;
                                            product_table_ref.value.tableData.filter((x, i) => { if (x.id === data.id) product_table_ref.value.tableData.splice(i, 1); } );
                                            product_table_ref.value.reCalculateTotal();
                                            G.alert.success(res.detail);
                                        },
                                        // error: (e) => {
                                        //     const res = e.response || null;
                                        //     G.alert.error(res.detail);
                                        // }
                                    });
                                }, yesIcon: 'fas fa-check', noIcon: 'fas fa-ban', noTitle: TR.value.no, no: () => {} })
                            },
                        },
                        {
                            // private: G.privateIfNotPermission("update"),
                            title: TR.value.edit,
                            // icon: "fas fa-pencil-alt",
                            // class: "btn-primary",
                            icon: "fas fa-" + ( G.userHavePermission("update") ? 'pencil-alt' : 'search' ),
                            class: "text-" + ( G.userHavePermission("update") ? 'primary' : 'info' ),
                            eventCallback: (data) => {
                                data.permission_method = 'update';

                                G.showModal({
                                    title: TR.value.edit_title,
                                    subTitle: `<span class="text-danger1">${data.product_code}</span> - ${G.formatLocale(data.create_date)}`,
                                    page: "pages/products/ProductsInfo",
                                    data: data,
                                    table_columns_forlang: [
                                        {
                                            name: "name",
                                            title: TR.value.name,
                                            // value: (e) => e.translate[0].name,
                                            value: (l) => l.name,
                                            field_type: "text",
                                        },
                                        {
                                            name: "description",
                                            title: TR.value.description,
                                            // value: (e) => e.translate[0].description,
                                            value: (l) => l.description,
                                            field_type: "editor",
                                        },
                                    ],
                                    table_columns: [
                                        {
                                            name: "id",
                                            title: TR.value.id,
                                            value: "id",
                                        },
                                        // {
                                        //     name: "product_code",
                                        //     title: TR.value.code,
                                        //     value: "product_code",
                                        //     // field_type: "text",
                                        //     field_type: "selectbox",
                                        //     selectbox_items: [],
                                        //     showList: false,
                                        //     onInput: (e, item) => getProductCodes(e, item),
                                        //     selectbox_item_selected: data.product_code,
                                        //     required: true,
                                        // },
                                        // {
                                        //     name: "product_code",
                                        //     title: TR.value.code,
                                        //     value: "product_code",
                                        //     field_type: "text",
                                        //     required: true,
                                        // },
                                        // {
                                        //     name: "name",
                                        //     title: TR.value.name,
                                        //     value: (e) => e.translate[0].name,
                                        //     field_type: "text",
                                        // },
                                        // {
                                        //     name: "description",
                                        //     title: TR.value.description,
                                        //     value: (e) => e.translate[0].description,
                                        //     field_type: "textarea",
                                        // },
                                        // {
                                        //     name: "quantity",
                                        //     title: TR.value.quantity,
                                        //     // value: "quantity", //(e) => e.translate[0].name,
                                        //     value: () => 1,
                                        //     field_type: "integer",
                                        //     required: true,
                                        //     max: 100000000,
                                        // },
                                        // {
                                        //     name: "come_in_price",
                                        //     title: TR.value.come_in_price,
                                        //     value: "come_in_price",
                                        //     field_type: "currency",
                                        //     required: true,
                                        //     max: 100000000.00,
                                        // },
                                        {
                                            name: "price",
                                            title: TR.value.price,
                                            value: "price",
                                            field_type: "numeric",
                                            required: true,
                                            max: 100000000.00,
                                            grouping: true,
                                        },
                                        {
                                            name: "years",
                                            title: TR.value.year,
                                            value: "years",
                                            field_type: "integer",
                                            max: 3000,
                                            default: 2020,
                                        },
                                        {
                                            name: "months",
                                            title: TR.value.month,
                                            value: "months",
                                            field_type: "integer",
                                            max: 12,
                                            default: 1,
                                        },
                                        {
                                            name: "quarters",
                                            title: TR.value.quarter,
                                            value: "quarters",
                                            field_type: "integer",
                                            max: 4,
                                            default: 1,
                                        },
                                        // {
                                        //     name: "old_price",
                                        //     title: TR.value.old_price,
                                        //     value: "old_price",
                                        //     field_type: "currency",
                                        //     max: 100000000.00,
                                        // },
                                        {
                                            name: "category_id",
                                            title: TR.value.category,
                                            value: "category_id",
                                            field_type: "dropdown",
                                            dropdown_items: category.value,
                                            dropdown_item_selected: data.category_id,
                                        },
                                        {
                                            name: "product_filters",
                                            title: TR.value.filters,
                                            // value: "product_filters",
                                            field_type: "multiselect",
                                            dropdown_items: filters.value,
                                            dropdown_item_selected: data.product_filters.map(f => f.filter_id),
                                            // dropdown_item_selected: data.filters.map(c => c.filter_id),
                                        },
                                        // {
                                        //     name: "model",
                                        //     title: TR.value.model,
                                        //     value: "model",
                                        //     field_type: "text",
                                        // },
                                        // {
                                        //     name: "width",
                                        //     title: TR.value.width,
                                        //     value: "width",
                                        //     field_type: "integer",
                                        //     max: 100000000,
                                        // },
                                        // {
                                        //     name: "height",
                                        //     title: TR.value.height,
                                        //     value: "height",
                                        //     field_type: "integer",
                                        //     max: 100000000,
                                        // },
                                        // {
                                        //     name: "box",
                                        //     title: TR.value.box,
                                        //     value: "box",
                                        //     field_type: "integer",
                                        //     max: 100000000,
                                        // },
                                        // {
                                        //     name: "per_box",
                                        //     title: TR.value.per_box,
                                        //     value: "per_box",
                                        //     field_type: "integer",
                                        //     max: 100000000,
                                        // },
                                        // {
                                        //     name: "weight",
                                        //     title: TR.value.weight,
                                        //     value: "weight",
                                        //     field_type: "integer",
                                        //     max: 100000000,
                                        // },
                                        // {
                                        //     name: "length",
                                        //     title: TR.value.length,
                                        //     value: "length",
                                        //     field_type: "integer",
                                        //     max: 100000000,
                                        // },
                                        // {
                                        //     name: "ean",
                                        //     title: TR.value.ean,
                                        //     value: "ean",
                                        //     field_type: "text",
                                        // },
                                        // {
                                        //     name: "sku",
                                        //     title: TR.value.sku,
                                        //     value: "sku",
                                        //     field_type: "text",
                                        // },
                                        // {
                                        //     name: "upc",
                                        //     title: TR.value.upc,
                                        //     value: "upc",
                                        //     field_type: "text",
                                        // },
                                        // {
                                        //     name: "isbn",
                                        //     title: TR.value.isbn,
                                        //     value: "isbn",
                                        //     field_type: "text",
                                        // },
                                        // {
                                        //     name: "jan",
                                        //     title: TR.value.jan,
                                        //     value: "jan",
                                        //     field_type: "text",
                                        // },
                                        // {
                                        //     name: "mpn",
                                        //     title: TR.value.mpn,
                                        //     value: "mpn",
                                        //     field_type: "text",
                                        // },
                                        {
                                            name: "create_date",
                                            value: (e) => G.formatLocale(e.create_date),
                                            title: TR.value.create_date,
                                            field_type: "label",
                                        },
                                        {
                                            name: "status",
                                            title: TR.value.status,
                                            value: (e) => e.status == 1 ? true : false,
                                            field_type: "switch",
                                        },
                                    ],
                                    toolbar: {
                                        leftSide: {
                                            buttons: [
                                                {
                                                    label: TR.value.close,
                                                    icon: "fas fa-times",
                                                    class: "btn-secondary",
                                                    eventCallback: (el) => {
                                                        G.closeModal(el);
                                                    },
                                                },
                                                {
                                                    private: G.privateIfNotPermission("update"),
                                                    label: TR.value.save,
                                                    icon: "fas fa-save",
                                                    class: "btn-primary",
                                                    eventCallback: async (res) => {
                                                        let e = res.newdata;

                                                        let formData = new FormData();
                                                        if( e.images.length ){
                                                            Array.from(e.images).forEach(file => {
                                                                if( file instanceof Object ){
                                                                    formData.append('upload_image', file);
                                                                }
                                                            });
                                                        }

                                                        let product_data = {
                                                            // "product_code": e.product_code,
                                                            "category_id": e.category_id || null,
                                                            // "quantity": e.quantity,
                                                            // "come_in_price": e.come_in_price,
                                                            // "old_price": e.old_price,
                                                            "price": e.price,
                                                            "years": e.years,
                                                            "months": e.months,
                                                            "quarters": e.quarters,
                                                            // "upc": e.upc,
                                                            // "model": e.model,
                                                            "status": e.status ? 1 : 0,
                                                            "translate": G.lang_list.map((a) => (
                                                                {
                                                                    "lang_id": a.value,
                                                                    "name": e.name[a.value] || e.name[1],
                                                                    "description": e.description[a.value],
                                                                }
                                                            )),
                                                            "product_images": e.new_product_images,
                                                            "product_filters": e.product_filters,
                                                        };

                                                        formData.append("data", JSON.stringify(product_data));

                                                        await ajax({
                                                            url: store.getProductsUpdate(data.id),
                                                            method: 'patch',
                                                            data: formData,
                                                            success: (x) => {
                                                                const res = x.data || null;
                                                                if ( x.status == 200 && res) {
                                                                    // res.create_date = new Date(res.create_date);
                                                                    res.create_date = moment.utc(res.create_date).tz(G.systemData.timezone?.value).format(G.datetime_format['datetime']);
                                                                    product_table_ref.value.tableData.forEach(
                                                                        (s) => { if ( s.id === res.id ) { s = res; } }
                                                                    );
                                                                    for (let a in res) {
                                                                        data[a] = res[a];
                                                                    }
                                                                    product_table_ref.value.reCalculateTotal();
                                                                    G.alert.success(TR.value.msg_update_success);
                                                                }
                                                                else{
                                                                    G.alert.error(res.detail);
                                                                }
                                                            },
                                                        });
                                                        G.closeModal(res);
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                });
                            },
                        },
                        {
                            private: G.privateIfNotPermission("update"),
                            name: 'status',
                            title: TR.value.status,
                            value: (e) => e.status == 0 ? false : true,
                            class: 'text-center',
                            element: 'switch',
                            eventName: 'change',
                            eventCallback: async (data, event) => {
                                await ajax({
                                    url: store.getProductsActivate(data.id, event.target.checked ? 1 : 0),
                                    method: 'post',
                                    success: (a) => {
                                        let res = a.data || undefined;
                                        if ( a.status == 200 && res) {
                                            // res.create_date = new Date(moment.utc(res.create_date).tz(G.systemData.timezone?.value).format(G.datetime_format['pg_datetime']));
                                            res.create_date = moment.utc(res.create_date).tz(G.systemData.timezone?.value).format(G.datetime_format['datetime']);
                                            // res.create_date = new Date(res.create_date);
                                            product_table_ref.value.tableData.forEach(
                                                (s) => { if ( s.id === res.id ) { s = res; } }
                                            );
                                            for (let a in res) {
                                                data[a] = res[a];
                                            }
                                            product_table_ref.value.reCalculateTotal();
                                            G.alert.success({toast: true, msg: TR.value.msg_update_success});
                                        }
                                        else{
                                            G.alert.error(res.detail);
                                        }
                                    }
                                });
                            },
                        },
                    ],
                    data_table_columns: [
                        {
                            name: "id",
                            title: TR.value.id,
                            value: "id",
                            class: 'text-center',
                            filter: false,
                        },
                        {
                            name: "image",
                            value: (e) => {
                                return `<img
                                src="${
                                    e.product_images.length && e.product_images[0]
                                    && e.product_images[0].image instanceof Object === false //&& e.product_images[0].image.match(/^http[\s]?:\/\//mgi)
                                                    ? e.product_images[0].image
                                                    : "/assets/img/noimg.png"
                                            }"
                                            alt="${e.product_images.length ? e.product_images[0].image : ''}"
                                            class="border img-circle-cover"
                                        />`},
                            title: TR.value.image,
                            exportable: false,
                            sortable: false,
                            filter: false,
                        },
                        // {
                        //     name: "product_code",
                        //     value: (e) => e.product_code,
                        //     title: `${TR.value.code}`,
                        // },
                        {
                            name: "name",
                            value: (e) => e.translate[0].name,
                            title: `${TR.value.name}`,
                        },
                        {
                            name: "category_id",
                            title: TR.value.category,
                            // value: "category_id",
                            value: (e) => e.category_id && category.value.length ? category.value.filter((c) => c.value === e.category_id)[0].label : '',
                            filters: {
                                operator: "or",
                                constraints: [
                                    { value: null, matchMode: 'equals' },
                                ],
                            },
                            data_type: "customFilter",
                            filter_field: "category_id",
                            filter_mode: "dropdown",
                            dropdown_items: category.value,
                        },
                        {
                            name: "price",
                            value: "price",
                            title: TR.value.price,
                            filters: {
                                operator: "or",
                                constraints: [{ value: null, matchMode: "gte" }],
                            },
                            data_type: "numeric",
                            filter_mode: "currency",
                        },
                        {
                            name: "years",
                            value: "years",
                            title: TR.value.year,
                            filters: {
                                operator: "or",
                                constraints: [{ value: null, matchMode: "equals" }],
                            },
                            showTime: false,
                            // view_mode: "year",
                            // filter_format: 'yy',
                            data_type: "numeric",
                            filter_mode: "integer",
                            grouping: false,
                            min: 0,
                            max: 3000
                        },
                        // {
                        //     name: "manufacturer_id",
                        //     title: TR.value.manufacturer,
                        //     // value: "manufacturer_id",
                        //     value: (e) => manufacturer.value.length ? manufacturer.value.filter((x) => x.value === e.manufacturer_id)[0].label: '',
                        //     filters: {
                        //         operator: "or",
                        //         constraints: [
                        //             { value: null, matchMode: 'equals' },
                        //         ],
                        //     },
                        //     filter_field: "manufacturer_id",
                        //     filter_mode: "dropdown",
                        //     filter_dropdown_items: manufacturer.value,
                        // },
                        {
                            name: "product.create_date",
                            value: (e) => e.create_date,
                            // value: (e) => G.formatLocale(e.create_date),
                            title: TR.value.create_date,
                            filters: {
                                operator: "or",
                                constraints: [{ value: null, matchMode: "dateBefore" }],
                            },
                            filter_format: 'dd.mm.yy',
                            data_type: "date",
                            filter_mode: "datetime",
                        },
                    ],
                };

            });

            // var timeoutValue = null;
            // const getProductCodes = (event, item) => {
            //     if( timeoutValue )
            //         clearTimeout(timeoutValue);
            //     timeoutValue = setTimeout(async () => {
            //         var scode = G.strip(event.target.value, ' ');
            //         if( scode != '' ){
            //             await ajax({
            //                 url: store.getProductCodes( scode ),
            //                 success: (e) => {
            //                     // item.showList = true;
            //                     if( e.status == 200 && e.data ){
            //                         item.selectbox_items = e.data.map((x) => { return {"label": x.product_code} })
            //                     }
            //                 }
            //             });
            //         }
            //     }, 500);
            // };


            watchEffect(() => {
                TR.value = store.getTranslation();
            });

            return {
                TR,
                product_table_ref,
                tableOptions,
                lazyUrl,
                // getProductCodes,
            };
        },
    };
</script>

